module.exports = __webpack_public_path__ + "b1e8f24cacbb17a574a1eb7d7cd4c541.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/quarantaene_rr.jpg
// module id = 532
// module chunks = 0